
const LOCATION_STYLES = {
  DASHED_BLUE : {
    color: '#2196F3', // Line color
    fill: false,
    weight: 3,   // Line width
    dashArray: '2, 5', // Dotted pattern, numbers represent alternating lengths of dashes and gaps in pixels
    opacity: 0.5
  },
  DASHED_TRANSPARENT : {
    color: '#CCCCCC', // Line color
    fill: false,
    weight: 3,   // Line width
    dashArray: '2, 5', // Dotted pattern, numbers represent alternating lengths of dashes and gaps in pixels
    opacity: 0.5
  },
  DASHED_SOLID : {
    color: '#CCCCCC', // Line color
    fillColor: '#232323', // Fill color
    fillOpacity: 1,
    weight: 2,   // Line width
    dashArray: '2, 5', // Dotted pattern, numbers represent alternating lengths of dashes and gaps in pixels
  },
  BUILDING : {
    color: '#111111', // Line color
    fillColor: '#222222', // Fill color
    fillOpacity: 1,
    weight: 2,   // Line width
    
  },
  LEVEL : {
    color: '#111111', // Line color
    fillColor: '#222222', // Fill color
    fillOpacity: 1,
    weight: 2,   // Line width
    
  },
  ACTIVE : { 
    color: '#222222', // Line color
    weight: 3,   // Line width
    opacity: 1, // Line opacity
    fillColor: '#555555', // Fill color
    fillOpacity: 1,
  },
  SELECTED : { 
    color: '#2196F3', // Line color
    weight: 2,   // Line width
    opacity: 1, // Line opacity
    fillColor: '#555555', // Fill color
    fillOpacity: 1
  }
};

LOCATION_CONFIGS = {
  'Dashboard': {
    viewport:'all',
    childStyle: LOCATION_STYLES.DASHED_BLUE,
    markers: ['child'],
    polygons: ['child'],
  },
  'Site': {
    viewport:'all',
    childStyle: LOCATION_STYLES.ACTIVE,
    thisStyle: LOCATION_STYLES.DASHED_TRANSPARENT,
    markers: ['child'],
    polygons: ['this', 'child'],
  },
  'Building': {
    polygons: ['this', 'parent'],
    parentStyle: LOCATION_STYLES.DASHED_TRANSPARENT,
    markers: ['child'],
    viewport:'this',
    thisStyle: LOCATION_STYLES.BUILDING,
  },
  'Level': {
    viewport:'this',
    childStyle: LOCATION_STYLES.ACTIVE,
    thisStyle: LOCATION_STYLES.LEVEL,
    parentStyle: LOCATION_STYLES.BUILDING,
    grandparentStyle: LOCATION_STYLES.DASHED_TRANSPARENT,
    polygons: ['this', 'child', 'grandchild', 'parent'],
  },
  'Room': {
    viewport:'this',
    thisStyle: LOCATION_STYLES.SELECTED,
    siblingStyle: LOCATION_STYLES.ACTIVE,
    parentStyle: LOCATION_STYLES.BUILDING,
    grandparentStyle: LOCATION_STYLES.BUILDING,
    polygons: ['this', 'sibling', 'parent', 'grandparent', 'child'],
  },
  'System': {
    viewport: 'all',
    thisStyle: LOCATION_STYLES.DASHED_TRANSPARENT,
    polygons: ['this', 'parent'],
    markers: ['equipment'],
  }
};

module.exports = { LOCATION_CONFIGS , LOCATION_STYLES}